import { apiHttpService } from './apiHttpService';
import {
  Qualification,
  QualificationLevel,
} from '../features/Qualification/qualification';

export const fetchListQualifications = (
  personId: string,
): Promise<Qualification[]> => {
  return apiHttpService
    .get(`/api/Qualification/person/${personId}`)
    .then((response) => response.data);
};

export const upgradeQualification = (
  email: string,
  grantedByPersonId: string,
  testTypeId: string,
  level: QualificationLevel,
): Promise<Qualification> => {
  return apiHttpService
    .post(
      `/api/Qualification/upgrade?email=${encodeURIComponent(email)}&grantedByPersonId=${grantedByPersonId}&testTypeId=${testTypeId}&level=${level}`,
      {},
    )
    .then((response) => response.data);
};

export const updateQualification = (
  qualification: Qualification,
): Promise<Qualification> => {
  return apiHttpService
    .put(`/api/Qualification`, qualification)
    .then((response) => response.data);
};

export const deleteQualification = (id: string): Promise<Qualification> => {
  return apiHttpService
    .delete(`/api/Qualification?id=${id}`)
    .then((response) => response.data);
};

// eslint-disable-next-line
export default {
  fetchListQualifications,
  upgradeQualification,
  updateQualification,
  deleteQualification,
};
